import { render, staticRenderFns } from "./ReturnGood.vue?vue&type=template&id=5a9a9aea&"
import script from "./ReturnGood.vue?vue&type=script&lang=js&"
export * from "./ReturnGood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports